// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import {ssoUserResendActivationAction} from "../../actions/sso/creators/ssoUserActionCreator";
import * as _ from 'lodash';
import type {ResendActivationEmailModalDispatchProps, ResendActivationEmailModalStateProps} from "../../components/sso/ResendActivationEmailModal";
import ResendActivationEmailModal from "../../components/sso/ResendActivationEmailModal";
import {closeSsoUserResendActivationEmailModalAction} from "../../actions/modal/creators/ssoUserResendActivationEmailActionCreator";
import {extractCaller} from "../QueryPage";
import type {Caller} from "../../components/QueryPage";

const mapStateToProps = (state: StoreState): ResendActivationEmailModalStateProps => {

    const isLoading = state.modal.resendActivation.ssoUid
        ? _.get(state, `ssoUserAction.resendActivation.${state.modal.resendActivation.ssoUid}.isLoading`, false)
        : false;
    const error = state.modal.resendActivation.ssoUid
        ? _.get(state, `ssoUserAction.resendActivation.${state.modal.resendActivation.ssoUid}.error`)
        : undefined;

    return {
        open: state.modal.resendActivation.open,
        ssoUid: state.modal.resendActivation.ssoUid,
        caller: extractCaller(state),
        isLoading,
        error
    };
};

const mapDispatchToProps = (dispatch): ResendActivationEmailModalDispatchProps => {
    return {
        closeModal: () => {
            dispatch(closeSsoUserResendActivationEmailModalAction());
        },
        resendActivationEmail: (ssoUid: string, caller: Caller) => {
            dispatch(ssoUserResendActivationAction(ssoUid, caller));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResendActivationEmailModal);



// WEBPACK FOOTER //
// ./src/containers/sso/ResendActivationEmailModal.js